import { Tooltip } from "antd"
import { Render } from "../../../../../../../../Components/CustomUi/render"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleExclamation, faInfoCircle, faWarning } from "@fortawesome/free-solid-svg-icons"
import { useState } from "react";
import { useGetSafraConsultoria } from "../../../../../../../../services/Safra/GET";
import { InfoAdicionais } from "../infoAdicionais";
import { VisualizarInconsistencia } from "../visualizarInconsistencia";

//PROPS
interface Props {
    resultado_inconsistente: number;
    observacao: string;
    cod_safra_conta: number;
    laboratorio_nome: string;
    cod_calcario: number;
    cod_calcario_propriedade: number;
    /** Status da OS: 6/7 (inconsistência) e 8 (resultado com erro) também
     *  disparam o alerta, além de `resultado_inconsistente`. */
    status?: number;
}

export const IconeAlerta: React.FC<Props> = ({ resultado_inconsistente, observacao, cod_safra_conta, laboratorio_nome,
    cod_calcario, cod_calcario_propriedade, status
}) => {

    //#region STATES
    const [abrirInconsistencia, setAbrirInconsistencia] = useState<boolean>(false);
    const [textoInconsistencia, setTextoInconsistencia] = useState<string>('');
    const [calcarios, setCalcarios] = useState<{ cod_calcario: number, cod_calcario_propriedade: number }>({ cod_calcario: null, cod_calcario_propriedade: null });

    //#API
    const { data_safras, carregando_safras } = useGetSafraConsultoria();

    // Regra de produção: além do resultado_inconsistente, os status
    // INCONSISTÊNCIA MODERADA (6), ALTA (7) e RESULTADO COM ERRO (8) alertam.
    const erro = status === 8;
    const alertar = resultado_inconsistente === 1 || status === 6 || status === 7 || erro;
    const calcarioDivergente = cod_calcario !== cod_calcario_propriedade;

    return (
        <>
        <Tooltip
            trigger='hover'
            placement='right'
            color='#fff'
            overlayInnerStyle={{
                color: '#000',
                padding: 12,
                borderRadius: 8,
                minWidth: alertar ? '350px' : '220px',
            }}
            title={
                <InfoAdicionais
                    resultado_inconsistente={resultado_inconsistente}
                    status={status}
                    dataSafraConsultoria={data_safras}
                    cod_safra_conta={cod_safra_conta}
                    laboratorio_nome={laboratorio_nome}
                    calcarios={calcarios}
                    chamarModalInconsistencia={() => {
                        setAbrirInconsistencia(true)
                        setTextoInconsistencia(observacao)
                        setCalcarios({ cod_calcario, cod_calcario_propriedade })
                    }}
                />
            }
        >
            <Render condition={alertar}>
                <div
                    style={{
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <FontAwesomeIcon
                        icon={erro ? faCircleExclamation : faWarning}
                        style={{
                            fontSize: 18,
                            color: erro ? '#ff4d4f' : '#fdd500',
                            cursor: 'pointer',
                        }}
                    />
                </div>
            </Render>
            <Render condition={!alertar}>
                <div
                    style={{
                        width: '100%',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <FontAwesomeIcon
                        icon={calcarioDivergente ? faInfoCircle : faWarning}
                        style={{
                            fontSize: 18,
                            color: calcarioDivergente ? '#2586f5' : '#f08e0d',
                            cursor: 'pointer',
                        }}
                    />
                </div>
            </Render>
        </Tooltip>

        <VisualizarInconsistencia
            abrir={abrirInconsistencia}
            setAbrir={setAbrirInconsistencia}
            texto={textoInconsistencia}
        />
        </>
    )
}